export enum aiQueryKeys {
  getBusinessChatGptInterviewVoiceHistory = "getBusinessChatGptInterviewVoiceHistory",
  getBusinessChatGptInterviewHistory = "getBusinessChatGptInterviewHistory",
  getUserChatGptInterviewVoiceHistory = "getUserChatGptInterviewVoiceHistory",
  useGetUserSessionData = "useGetUserSessionData",
  getBusinessUserSessionData = "getBusinessUserSessionData",
  getSessionAnalysis = "getSessionAnalysis",
  getAllSession = "getAllSession",
  getBusinessClientAllSession = "getBusinessClientAllSession",
  getBusinessClientSessionAnalysis="getBusinessClientSessionAnalysis"
}
